<template>
    <diaLog tit="反馈问题" ref="dialog" @handleBtn="handleBtn" @handleClose="handleClose">
        <el-form :model="feedbackData" size="medium" ref="dialigFeedback" label-width="80px" :rules="ruleData">
            <el-form-item label="问题内容" prop="content">
                <el-input placeholder="如果你遇到功能方面的问题，或者有任何建议可填写在此处" type="textarea" maxlength="300" show-word-limit :rows="4" v-model="feedbackData.content" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="connect">
                <el-input placeholder="请填写手机号或微信号" v-model="feedbackData.connect" ></el-input>
                <p>请填写手机号或微信号，我们将第一时间就您提交的问题与您联系</p>
            </el-form-item>
        </el-form>
    </diaLog>
</template>

<script>
import diaLog from '@/components/diaLog'
export default {
    components: { diaLog },
    data() {
        return {
            feedbackData: {
                content: '',
                connect: '',
                type: 0
            },
            ruleData: {
                content: [{ required: true, message: '请输入问题内容', trigger: 'blur' }],
                connect: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
            }
        }
    },
    methods: {
        handleBtn() {
            this.$refs['dialigFeedback'].validate((valid) => {
                if (!valid) return false
                this.dialogBtnLoadingState(true)
                this.$emit('handleBtn', this.feedbackData)
            })
        },
        dialogBtnLoadingState(state) {
            this.$refs.dialog.loading = state
        },
        handleClose() {
            this.$emit('handleClose', false)
        }
    },
}
</script>
